import { AxiosHeaders, isAxiosError } from 'axios';

export const SESSION_EXPIRED_EVENT = 'manager:session-expired';
const INVALID_SESSION_CODES = new Set(['TOKEN_EXPIRED', 'TOKEN_INVALID', 'TOKEN_MISSING']);

export function requestSessionToken(error: unknown): string | null {
  if (!isAxiosError(error)) return null;
  const authorization = AxiosHeaders.from(error.config?.headers).get('Authorization');
  return typeof authorization === 'string' && authorization.startsWith('Bearer ') ? authorization.slice(7) : null;
}

export function isSessionValidationRequest(error: unknown): boolean {
  return isAxiosError(error) && /\/auth\/me\/?$/.test((error.config?.url ?? '').split('?')[0]);
}

export function isCredentialRequest(error: unknown): boolean {
  return isAxiosError(error) && /\/auth\/(?:login|2fa\/(?:verify|enroll\/(?:start|confirm)))\/?$/.test((error.config?.url ?? '').split('?')[0]);
}

export function isDefinitiveSessionError(error: unknown): boolean {
  if (!isAxiosError(error) || error.response?.status !== 401 || isCredentialRequest(error)) return false;
  return isSessionValidationRequest(error) || INVALID_SESSION_CODES.has(error.response.data?.code);
}

/** A late response from an old session must never erase a newer login. */
export function invalidateSession(token: string): boolean {
  if (localStorage.getItem('token') !== token) return false;
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
  return true;
}
